// extracted by mini-css-extract-plugin
export default {"root":"Overlay_root__73T44","button":"Overlay_button__52ei8"};